import { Component, OnInit } from "@angular/core";
import { Commande } from "../models/Commande.model";
import { CommandeService } from "../_services/commande.service";

@Component({
  selector: "app-commande",
  templateUrl: "./commande.component.html",
  styleUrls: ["./commande.component.css"],
})
export class CommandeComponent implements OnInit {
  commandes: Commande[];
  p: number = 1;
  filterItems: any;
  mot:any;
  showSpinner: boolean = true;
  showSpinnerMail: boolean = false;
  items = [
    { id: 1, libelle: "Terminé" },
    { id: 2, libelle: "En cours" },
    { id: 3, libelle: "Livré" },
  ];
  selected;
  constructor(private commandeService: CommandeService) {}

  ngOnInit() {
    this.LoadAllCommande();
    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }
  getValues() {
    console.log(this.selected);
    if (this.selected == null) {
      this.LoadAllCommande();
    } else {
      this.FilterEtatCommande();
    }
  }
  LoadAllCommande() {
    this.commandeService.getData().subscribe((data: Commande[]) => {
      this.commandes = data;
      this.filterItems = this.commandes;
      this.showSpinner = false;
    });
  }
  FilterEtatCommande() {
    this.filterItems = this.commandes.filter((item) => {
      return item.etat.indexOf(this.selected.libelle) > -1;
    });
  }
}
